export default __webpack_public_path__ + "static/media/Manipal.262b4290.png";